var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 132,
    viewBox: "0 0 107 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23746 4.32516C3.28966 1.99891 5.05534 0.160605 7.18187 0.217343L67.2558 1.84458C91.1357 2.49139 107.599 22.2384 106.979 49.5656C106.35 77.2945 88.0877 96.5036 62.9211 95.8205L44.7287 95.328C42.6021 95.2713 40.8365 97.1096 40.7843 99.4358L40.1465 127.582C40.0943 129.909 38.3287 131.747 36.2021 131.69L4.22469 130.823C2.09816 130.766 0.418712 128.833 0.470911 126.509L3.23746 4.32743V4.32516Z",
    fill: "#FEBF88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPLetter);
export default __webpack_public_path__ + "static/media/p-letter.de356330a1e4f4f5db9cb4d9403dd40c.svg";
export { ForwardRef as ReactComponent };